import { render, staticRenderFns } from "./CategoryFilter.vue?vue&type=template&id=63453d2b&scoped=true&"
import script from "./CategoryFilter.vue?vue&type=script&lang=js&"
export * from "./CategoryFilter.vue?vue&type=script&lang=js&"
import style0 from "./CategoryFilter.vue?vue&type=style&index=0&id=63453d2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63453d2b",
  null
  
)

export default component.exports